import Link from "next/link";

export function SocialInvestorSection() {
	return (
		<div className="w-full py-4 bg-white">
			<h2 className="text-center text-2xl font-bold mb-4">Investidor Social</h2>
			<div className="mx-auto w-max">
				<img
					alt="Empresas parceiras da jornada do paciente"
					title="Empresas parceiras da jornada do paciente"
					src="/assets/images/logos/selo.svg"
					className="h-auto w-[12rem] lg:w-[12rem]"
				/>
			</div>

			<div className="flex flex-wrap gap-6 justify-center">
				<Link
					className="flex flex-col gap-y-0 md:flex-row items-center justify-center"
					target="_blank"
					href="https://www.takeda.com/pt-br"
				>
					<img
						alt="Acessar o site da Takeda Pharmaceutical Company"
						title="Acessar o site da Takeda Pharmaceutical Company"
						src="https://res.cloudinary.com/oliveiradev/image/upload/v1787378570/InstitutoDeixeVivo/investidor-social/Dakiyama_2021_Red_DIGITAL_2.svg"
						className="h-auto w-[20rem]"
					/>
				</Link>
				<Link
					className="flex flex-col gap-y-0 md:flex-row items-center justify-center"
					target="_blank"
					href="https://www.novartis.com/br-pt/"
				>
					<img
						alt="Acessar o site da Novartis Brasil"
						title="Acessar o site da Novartis Brasil"
						src="https://res.cloudinary.com/oliveiradev/image/upload/v1787378406/InstitutoDeixeVivo/investidor-social/logo-novartis-black-rgb.png"
						className="h-auto w-[20rem]"
					/>
				</Link>
			</div>
		</div>
	);
}
